import QtdModulo from '../../ModulosCrefito/QtdModulo'
import OutrosDados from '../../ModulosCrefito/Modulos/OutrosDados'
import OrientacoesNotificacao from '../../ModulosCrefito/Modulos/OrientacoesNotificacao'
import ResponsavelFisc from '../../ModulosCrefito/Modulos/ResponsavelFisc'
import ProfissionaisNoEstabelecimento from '../../ModulosCrefito/Modulos/ProfissionaisNoEstabelecimento'
import Estagio from '../../ModulosCrefito/Modulos/Estagio'
import SetoresComFisio from '../../ModulosCrefito/Modulos/SetoresComFisio'
import Emergencia from '../../ModulosCrefito/Modulos/Emergencia'
import Uti from '../../ModulosCrefito/Modulos/Uti'
import Uci from '../../ModulosCrefito/Modulos/Uci'
import Ucin from '../../ModulosCrefito/Modulos/Ucin'
import Enfermaria from '../../ModulosCrefito/Modulos/Enfermaria'
import Transporte from '../../ModulosCrefito/Modulos/Transporte'
import Ambulatorio from '../../ModulosCrefito/Modulos/Ambulatorio'
import Residencia from '../../ModulosCrefito/Modulos/Residencia'
import AtribuicoesExtra from '../../ModulosCrefito/Modulos/AtribuicoesExtra'
import RegistroProntuario from '../../ModulosCrefito/Modulos/RegistroProntuario'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Hospital = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="responsavelfisc" />
            <ResponsavelFisc modulo="responsavelfisc" />
            <QtdModulo texto="FISIOTERAPEUTAS QUE TRABALHAM NO ESTABELECIMENTO" modulo="profissionais" />
            <ProfissionaisNoEstabelecimento modulo="profissionais" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="prontuario" />
            <RegistroProntuario modulo="prontuario" />
            <QtdModulo texto="SETORES DE ASSISTÊNCIA QUE POSSUEM FISIOTERAPEUTA" modulo="setorcomfisio" />
            <SetoresComFisio modulo="setorcomfisio" />
            <QtdModulo texto="EMERGÊNCIA" modulo="emergencia" />
            <Emergencia modulo="emergencia" />
            <QtdModulo texto="UTI" modulo="uti" />
            <Uti modulo="uti" />
            <QtdModulo texto="UCI" modulo="uci" />
            <Uci modulo="uci" />
            <QtdModulo texto="UCIN" modulo="ucin" />
            <Ucin modulo="ucin" />
            <QtdModulo texto="ENFERMARIA" modulo="enfermaria" />
            <Enfermaria modulo="enfermaria" />
            <QtdModulo texto="EQUIPE DE TRANSPORTE" modulo="transporte" />
            <Transporte modulo="transporte" />
            <QtdModulo texto="AMBULATÓRIO" modulo="ambulatorio" />
            <Ambulatorio modulo="ambulatorio" />
            <QtdModulo texto="ESTÁGIO" modulo="estagios" />
            <Estagio modulo="estagios" />
            <QtdModulo texto="PROGRAMA DE RESIDÊNCIA" modulo="residencia" />
            <Residencia modulo="residencia" />
            <QtdModulo texto="ATRIBUIÇÕES EXTRA-PROFISSIONAL" modulo="atribuicoes" />
            <AtribuicoesExtra modulo="atribuicoes" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="outrosDados" />
            <OutrosDados modulo="outrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/NOTIFICAÇÕES" modulo="orientacoes" />
            <OrientacoesNotificacao modulo="orientacoes" />
        </>
    )
}

export default Hospital